module.exports = __webpack_public_path__ + "img/20191121102712679.5084999f.png";